﻿import React from 'react';

import styled from 'styled-components';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import NumberInput from '../../../Forms/Components/NumberInput';

import ConditionalFadeIn from '../../../UI/ConditionalFadeIn';
import Feedback from '../Components/Feedback';

import definitions from '../../../Style/LfStyleDefinitions';
import {required, isPositiveIntegerRange} from '../../../Forms/Validation/rules';

class Step1Form extends GuideFormBase {
    render() {
        const minAge = 18;
        const maxAge = 64;

        const formData = this.props.formData;
        const StepForm = this.stepFormWrapper;
        const NavigationButtons = this.navigationButtons;

        return (
            <StepForm heading="Hur gammal är du?">
                <NumberInput
                    theme="big"
                    innerLabel="år"
                    id="age"
                    name="age"
                    min="1"
                    step="1"
                    data-validation-error-message="Ange en ålder mellan 18 och 64 år"
                    validations={[required, isPositiveIntegerRange(minAge, maxAge)]}
                    placeholder="0"
                    value={this.props.formData.age}
                />

                <h5 aria-describedby="working-abroad">Jag började jobba vid *</h5>

                <NumberInput
                    theme="big"
                    innerLabel="år"
                    id="startedWorkAge"
                    name="startedWorkAge"
                    min="1"
                    step="1"
                    data-validation-error-message="Ange en korrekt ålder"
                    validations={[required, isPositiveIntegerRange(0, this.props.formData.age)]}
                    placeholder="0"
                    value={this.props.formData.startedWorkAge}
                />

                <WorkingAbroad id="working-abroad">* Om du tidigare i ditt liv arbetat utomlands så väljer du det år du började arbeta i Sverige.</WorkingAbroad>

                <NavigationButtons />
                <NavigationButtons mobileOnly={true} />
            </StepForm>
        );
    }
}

// styles

const WorkingAbroad = styled.p`
    max-width: 350px;
    margin: 40px auto;
    font-size: 14px;
`;

export default connectForm(Step1Form);
